import React from 'react';
import { Link } from 'react-router-dom';
import { useBreakpoint } from './BreakpointProvider';
import { useHover } from './useHover';

// Navigation state the detail pages read (see "Back navigation" in CLAUDE.md)
export interface NavState {
  from?: string;
  stat?: string;
}

interface CardLinkProps {
  to: string;
  state?: NavState;
  style?: React.CSSProperties;
  // Merged over style while the pointer is over the card, on desktop only
  hoverStyle?: React.CSSProperties;
  title?: string;
  'aria-label'?: string;
  // For a link inside another clickable element, e.g. to stop the click from bubbling to it
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  children?: React.ReactNode;
}

const DEFAULT_HOVER: React.CSSProperties = { boxShadow: '0 4px 14px rgba(24,95,165,0.14)' };

// A clickable card that is a real link, so Ctrl-click, middle-click and "open in new tab"
// work. Replaces <div onClick={() => navigate(...)}> when a page is converted.
const CardLink = ({ to, state, style, hoverStyle = DEFAULT_HOVER, title, onClick, children, ...rest }: CardLinkProps) => {
  const { isDesktop } = useBreakpoint();
  const [hovered, hoverHandlers] = useHover();
  return (
    <Link
      to={to}
      state={state}
      title={title}
      aria-label={rest['aria-label']}
      onClick={onClick}
      {...hoverHandlers}
      style={{
        display: 'block',
        color: 'inherit',
        textDecoration: 'none',
        ...style,
        ...(isDesktop && hovered ? hoverStyle : null),
      }}
    >
      {children}
    </Link>
  );
};

export default CardLink;
